import IncomeSection from './IncomeSection';
import ExpenseSection from './ExpenseSection';
import MonthlyIncomeSection from './MonthlyIncomeSection';
import { generateScheduleIJ } from './IJGenerators';
import { generateDecPage } from './decGenerator';
import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { generateChapter7ServicePacket, generateSchedulesPdfLocal } from './ScheduleDEF';
import { useParams } from 'react-router-dom';
import { PDFDocument } from 'pdf-lib';
import medianData from '../../json/median_income.json';
import {
  generateInstallmentAppPdf,
  generateSSNVerificationPdf,
  generatePaymentAdvicesPdf,
  generateAttorneyCompensationPdf,
  generateDEBNFormsPdf,
  fillFormBrowser
} from "./pdfGenerators";
import { generateSofa } from './SOFAPDFGenerator';
import { generateSummary,
        getTotalIncome,
 } from './summaryGenerator';
import { generateScheduleABC } from './ABCpdfGenerators';
import { filingDebtors as getFilingDebtors } from '../../utils/debtors';
import FilingPackagePanel from './FilingPackagePanel';
import { buildDebtorTextBlob } from './debtorTextGenerator';
import { buildCreditorsTextBlob } from './creditorTextGenerator';
import { calculateLongFormMeansTest } from '../../utils/longFormMeansTest';

const STATE_NAMES = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
    HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
    KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
    MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi',
    MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire',
    NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina',
    ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania',
    RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee',
    TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington',
    WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming', DC: 'District of Columbia'
  };

const exemptionScopeForCase = caseRecord => {
  const savedScope = String(caseRecord?.exemption_scope || '').trim();
  if (savedScope.toLowerCase() === 'federal') return 'federal';
  if (savedScope) return savedScope.toUpperCase();

  const debtors = Array.isArray(caseRecord?.debtors) ? caseRecord.debtors : [];
  const filingDebtor = debtors.find(debtor => debtor.is_primary && debtor.is_filing)
    || debtors.find(debtor => debtor.is_filing)
    || debtors[0];
  const debtorState = String(filingDebtor?.state || '').toUpperCase();
  return Object.prototype.hasOwnProperty.call(STATE_NAMES, debtorState) ? debtorState : 'TN';
};

const API_URL2 = process.env.REACT_APP_BACKEND_URL
const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem('accessToken');
const TOKEN = localStorage.getItem('accessToken');

const API_URL = process.env.REACT_APP_API_URL;

const calcGrossWages = emp => {
const rate = Number(emp.pay_rate) || 0;
const units = Number(emp.pay_units) || 0;
const frequencyFactor = (() => {
    switch (emp.pay_schedule) {
    case 'hourly': return (units * 52) / 12;
    case 'weekly': return 52 / 12;
    case 'biweekly': return 26 / 12;
    case 'semimonthly': return 2;
    case 'monthly': return 1;
    case 'yearly': return 1 / 12;
    default: return 0;
    }
})();
const gross = rate * frequencyFactor;
return gross;
};

  

export default function AllForms() {
  const [isGeneratingVOLP, setIsGeneratingVOLP] = useState(false);
  const [generatedSofaData, setGeneratedSofaData] = useState(null);
      const [selectedSchedules, setSelectedSchedules] = useState(['all']);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  const [creditors, setCreditors] = useState([]);
  const { caseId } = useParams();
    const [householdLoading, setHouseholdLoading] = useState(true);
    const [householdError, setHouseholdError] = useState(null);
      const [vehicleLoading, setVehicleLoading] = useState(true);
      const [vehicleError, setVehicleError] = useState(null);
  const [realProperties, setRealProperties] = useState([]);
    const [vehicles, setVehicles] = useState([]);
      const [caseData, setCaseData] = useState(null);
      const [exemptions, setExemptions] = useState([]);
      const [scope, setScope] = useState('');
      const [financialAssets, setFinancialAssets] = useState({});
      const [businessAssets, setBusinessAssets] = useState({});
      const [farmAssets, setFarmAssets] = useState({});
      const [otherProperties, setOtherProperties] = useState([]);
        const [householdItems, setHouseholdItems] = useState([]);
      const [expenses, setExpenses] = useState([]);
      const [installments, setInstallments] = useState([]);
      const [dependents, setDependents] = useState([]);
      const [expenseSheet, setExpenseSheet] = useState(null);
      const [incomeItems, setIncomeItems] = useState([]);
      const [meansTestIncomes, setMeansTestIncomes] = useState([]);
      const [maritalAdjustments, setMaritalAdjustments] = useState([]);
      const [longFormData, setLongFormData] = useState({});
  const [petitionData, setPetitionData] = useState({
    debtors: [],
    chapter: '',
    first_name: '',
    second_name: '',
    last_name: '',
    aliases: [],
    ssn: '',
    street: '',
    street2: '',
    city: '',
    state: '',
    zip_code: '',
    county: '',
    mailing_street: '',
    mailing_street2: '',
    mailing_city: '',
    mailing_state: '',
    mailing_zip_code: '',
    prior_bankruptcies: [],
    intake_data: {},
    filing_fee_method: '',
    filing_fee_amount: '',
    debt_type: '',
    execution_date: new Date().toISOString().split('T')[0],
    alternative_venue_reason: '',
    being_evicted: false,
    liquidated_assets_in_7: false,
    pending_bankruptcies: [],
    amended: false,
    amendedReason: '',
    amendedCreditors: [],
    total_attorney_fees: '',
    fees_paid_prior: '',
    share_fees: false,
    fees_source:'',
    fees_source_description:'',
    fees_to_be_paid_source:'',
    fees_to_be_paid_description:'',
  });
      const [data, setData] = useState({
        debtsD: [], // array of secured creditors
        debtsE: [], // array of priority creditors
        debtsF: [], // array of nonpriority unsecured creditors
        debtsG: [],
        notifyEF: [], // array of others to notify
        allDebts: [],
        caseInfo: {}, // case metadata: number, name, etc.
        amended: false,
        amendedReason: '',
        amendedCreditors: [],
      });
  // Unified loading flags for all prerequisites
  const [loadFlags, setLoadFlags] = useState({
    expenses: false,
    installments: false,
    dependents: false,
    expenseSheet: false,
    means: false,
    maritalAdj: false,
    sofa: false,
    incomeItems: false,

    petition: false,
    caseCreditors: false,

    realProps: false,
    vehicles: false,
    household: false,
    caseOverview: false,
    exemptions: false,
    finAssets: false,
    bizAssets: false,
    farmAssets: false,
    otherProps: false,
  });

  // Helper to mark multiple flags at once (always mark as finished even on error so we can surface UI)
  const markFlagsDone = (keys) => {
    setLoadFlags(prev => {
      const next = { ...prev };
      keys.forEach(k => next[k] = true);
      return next;
    });
  };

  // Pretty labels for the overlay checklist
  const loadingLabels = {
    expenses: 'Expenses',
    installments: 'Installment Payments',
    dependents: 'Dependents',
    expenseSheet: 'Expense Worksheet',
    means: 'Means Test Incomes',
    maritalAdj: 'Marital Adjustments',
    sofa: 'SOFA Data',
    incomeItems: 'Income Items',

    petition: 'Voluntary Petition Data',
    caseCreditors: 'Case Details & Creditors',

    realProps: 'Real Properties',
    vehicles: 'Vehicles',
    household: 'Household Goods',
    caseOverview: 'Case Overview',
    exemptions: 'Exemptions',
    finAssets: 'Financial Assets',
    bizAssets: 'Business Assets',
    farmAssets: 'Farm Assets',
    otherProps: 'Other Properties',
  };

  const allReady = Object.values(loadFlags).every(Boolean);
  const pendingList = Object.entries(loadFlags)
    .filter(([, done]) => !done)
    .map(([key]) => loadingLabels[key] || key);

  async function handleVOLPGenerate(pData) {
    if (isGeneratingVOLP) return;
    if (!allReady) return;
    setIsGeneratingVOLP(true);
    try {
      const VOLP = await fillFormBrowser(pData);
      if (VOLP instanceof Blob) {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(VOLP);
        link.download = '101 Voluntary Petition.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        console.error('fillFormBrowser did not return a Blob');
        alert('Failed to generate the Voluntary Petition PDF.');
      }
    } catch (e) {
      console.error('VOLP generation error:', e);
      alert('Failed to generate the Voluntary Petition PDF.');
    } finally {
      setIsGeneratingVOLP(false);
    }
  }

  const mergePdfBlobs = async blobs => {
    const mergedPdf = await PDFDocument.create();
    for (const blob of blobs) {
      if (!(blob instanceof Blob)) throw new Error('One of the filing forms did not generate correctly.');
      const source = await PDFDocument.load(await blob.arrayBuffer());
      const pages = await mergedPdf.copyPages(source, source.getPageIndices());
      pages.forEach(page => mergedPdf.addPage(page));
    }
    return new Blob([await mergedPdf.save()], { type: 'application/pdf' });
  };

  const fetchLatestScheduleData = async () => {
    const token = localStorage.getItem('accessToken');
    const [caseResponse, creditorResponse, linkableAssetsResponse] = await Promise.all([
      fetch(`${API_URL}/case/${caseId}/creditors/case-details/`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      fetch(`${API_URL}/case/${caseId}/creditors/`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      fetch(`${API_URL}/case/${caseId}/creditors/linkable-assets/`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    ]);

    if (!caseResponse.ok || !creditorResponse.ok) {
      throw new Error('The latest case and creditor information could not be loaded.');
    }

    const caseDetails = await caseResponse.json();
    const allDebts = await creditorResponse.json();
    const linkableAssetsPayload = linkableAssetsResponse.ok
      ? await linkableAssetsResponse.json()
      : { assets: [] };
    const caseInfo = {
      ...caseDetails,
      linkable_assets: Array.isArray(linkableAssetsPayload.assets)
        ? linkableAssetsPayload.assets
        : [],
    };
    const latestData = {
      ...data,
      caseInfo,
      debtsD: allDebts.filter(debt => (
        String(debt.debt_type || '').trim().toLowerCase() === 'secured'
      )),
      debtsE: allDebts.filter(debt => (
        String(debt.debt_type || '').trim().toLowerCase() === 'priority'
      )),
      debtsF: allDebts.filter(debt => (
        String(debt.debt_type || '').trim().toLowerCase() === 'unsecured'
      )),
      debtsG: allDebts.filter(debt => (
        String(debt.debt_type || '').trim().toLowerCase() === 'executory'
      )),
      notifyEF: allDebts.filter(debt => debt.additional_notified),
      allDebts,
    };
    const latestCreditorAddresses = allDebts.map(creditor => ({
      name: creditor.account_name || creditor.name,
      street1: creditor.street1 || '',
      street2: creditor.street2 || '',
      city: creditor.city || '',
      state: creditor.state || '',
      zip_code: creditor.zip_code || '',
      codebtor: creditor.codebtor || '',
      codebtor_street1: creditor.codebtor_street1 || '',
      codebtor_street2: creditor.codebtor_street2 || '',
      codebtor_state: creditor.codebtor_state || '',
      codebtor_zip_code: creditor.codebtor_zip_code || '',
      codebtor_city: creditor.codebtor_city || '',
    }));

    setData(latestData);
    setCreditors(latestCreditorAddresses);
    return { data: latestData, creditors: latestCreditorAddresses };
  };

  const buildFullPetitionPackageBlob = async (
    generationData = data,
    generationCreditors = creditors,
  ) => {
    const scheduleABC = await generateScheduleABC({
      caseData,
      realProperties,
      vehicles,
      householdItems,
      financialAssets,
      businessAssets,
      farmAssets,
      otherProperties,
      exemptions,
      scope: exemptionScopeForCase(caseData),
      selectedSchedules: ['AB', 'C'],
      data: generationData,
    });
    const [scheduleDEF, matrix] = await generateSchedulesPdfLocal(
      generationData,
      false,
      ['D', 'EF', 'G', 'H', 'Matrix'],
      [],
    );
    const scheduleIJ = await generateScheduleIJ(
      caseData,
      expenses,
      expenseSheet,
      dependents,
      installments,
      ['I', 'J'],
      generationData,
      meansTestIncomes,
      maritalAdjustments,
      longFormData,
    );
    const summary = await generateSummary(
      caseData,
      generationData,
      expenses,
      installments,
      meansTestIncomes,
      realProperties,
      vehicles,
      householdItems,
      financialAssets,
      businessAssets,
      farmAssets,
      otherProperties,
      generationCreditors,
    );
    const [voluntaryPetition, sofa, declaration, form2010] = await Promise.all([
      fillFormBrowser(petitionData),
      generateSofa(caseData, generatedSofaData, generationData),
      generateDecPage(caseData),
      fetch('/forms/2010.pdf').then(response => {
        if (!response.ok) throw new Error('Form 2010 could not be loaded.');
        return response.blob();
      }),
    ]);
    return mergePdfBlobs([
      voluntaryPetition,
      sofa,
      summary,
      scheduleABC,
      scheduleDEF,
      scheduleIJ,
      declaration,
      form2010,
      matrix,
    ]);
  };

  const generateChapter13Packet = async serviceRecipients => {
    const response = await fetch(`${API_URL}/case/${caseId}/chapter-13-plan/generate-docx/`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amended: false,
        service_recipients: serviceRecipients.map(creditor => ({
          name: creditor.name,
          street1: creditor.street1,
          street2: creditor.street2,
          city: creditor.city,
          state: creditor.state,
          zip_code: creditor.zip_code,
          method: creditor.method,
        })),
      }),
    });
    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(payload.detail || payload.error || 'The Chapter 13 plan packet could not be generated.');
    }
    return response.blob();
  };

  const handleBuildFilingPackage = async ({
    creditCounselingUploadIds,
    paymentAdviceUploadIds,
    serviceRecipients,
    debnChoices,
  }) => {
    if (!allReady) throw new Error('Wait for all form data to finish loading.');

    const latest = await fetchLatestScheduleData();
    const generationData = latest.data;
    const generationCreditors = latest.creditors;
    const petitionPackage = await buildFullPetitionPackageBlob(
      generationData,
      generationCreditors,
    );
    const debtorTxt = await buildDebtorTextBlob({
      caseData,
      petitionData,
      data: generationData,
      expenses,
      installments,
      meansTestIncomes,
      dependents,
    });
    const creditorsTxt = buildCreditorsTextBlob(generationCreditors);
    const [ssn, paymentAdvicesForm, forms122, attorneyCompensation] = await Promise.all([
      generateSSNVerificationPdf(petitionData, { download: false }),
      generatePaymentAdvicesPdf(petitionData, { download: false }),
      generateScheduleIJ(
        caseData,
        expenses,
        expenseSheet,
        dependents,
        installments,
        ['122'],
        generationData,
        meansTestIncomes,
        maritalAdjustments,
        longFormData,
        { download: false, return122Parts: true },
      ),
      generateAttorneyCompensationPdf(petitionData, { download: false }),
    ]);

    const filingDebtorList = getFilingDebtors(petitionData.debtors);
    const debnPetitionData = {
      ...petitionData,
      debtors: petitionData.debtors.map(debtor => ({
        ...debtor,
        debn_notice: debnChoices[String(debtor.id)] === 'enroll',
      })),
    };
    const debnDocuments = await Promise.all(
      filingDebtorList.map(debtor => generateDEBNFormsPdf(
        debnPetitionData,
        debtor.is_primary,
        { download: false },
      )),
    );
    const filingFeeInstallments = petitionData.filing_fee_method === 'installment'
      ? await generateInstallmentAppPdf(petitionData, { download: false })
      : null;
    const chapterPacket = petitionData.chapter === '7'
      ? await generateChapter7ServicePacket(generationData)
      : await generateChapter13Packet(serviceRecipients);

    const form = new FormData();
    form.append('petition_package', petitionPackage, 'Full Petition Package.pdf');
    form.append('debtor_txt', debtorTxt, 'Debtor.txt');
    form.append('creditors_txt', creditorsTxt, 'creditors.txt');
    form.append('ssn', ssn, '121 SSN Statement.pdf');
    form.append('payment_advices_form', paymentAdvicesForm, '1007 Payment Advices.pdf');
    const shortForm122Name = petitionData.chapter === '7'
      ? '122A-1 Current Monthly Income.pdf'
      : '122C-1 Current Monthly Income.pdf';
    const longForm122Name = petitionData.chapter === '7'
      ? '122A-2 Means Test Calculation.pdf'
      : '122C-2 Disposable Income.pdf';
    if (!forms122?.shortForm) {
      throw new Error(`The ${shortForm122Name.replace('.pdf', '')} could not be generated.`);
    }
    form.append('forms_122_short', forms122.shortForm, shortForm122Name);
    if (forms122.longForm) {
      form.append('forms_122_long', forms122.longForm, longForm122Name);
    }
    form.append('attorney_compensation', attorneyCompensation, '2030 Attorney Compensation.pdf');
    filingDebtorList.forEach((debtor, index) => {
      form.append(
        debtor.is_primary ? 'debn_primary' : 'debn_secondary',
        debnDocuments[index],
        debtor.is_primary ? '9036 DEBN D1.pdf' : '9036 DEBN D2.pdf',
      );
    });
    if (filingFeeInstallments) {
      form.append('filing_fee_installments', filingFeeInstallments, '103A Filing Fee Installments.pdf');
    }
    form.append(
      petitionData.chapter === '7' ? 'chapter_7_packet' : 'chapter_13_packet',
      chapterPacket,
      petitionData.chapter === '7' ? 'chapter-7-service.zip' : 'chapter-13-plan.zip',
    );
    form.append('credit_counseling_upload_ids', JSON.stringify(creditCounselingUploadIds));
    form.append('payment_advice_upload_ids', JSON.stringify(paymentAdviceUploadIds));
    form.append('service_recipients', JSON.stringify(serviceRecipients));
    form.append('debn_choices', JSON.stringify(debnChoices));
    const meansCalculation = calculateLongFormMeansTest({
      caseData,
      dependents,
      meansTestIncomes,
      maritalAdjustments,
      longFormData,
    });
    form.append('means_test_filing', JSON.stringify({
      exempt_from_presumption: caseData.debt_type === 'business',
      presumption_status: 'no',
      line_11_current_monthly_income: Number(meansCalculation.combinedMonthly || 0).toFixed(2),
      line_14_current_monthly_income: Number(meansCalculation.combinedMonthly || 0).toFixed(2),
      disposable_income_determined: Boolean(meansCalculation.aboveMedian),
      commitment_period: meansCalculation.aboveMedian ? '5' : '3',
      long_form_required: Boolean(meansCalculation.aboveMedian),
      long_form_presumption: Boolean(meansCalculation.chapter7Presumption),
    }));

    const response = await fetch(`${API_URL}/case/${caseId}/filing-packages/`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      body: form,
    });
    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(payload.detail || payload.error || 'The filing package could not be saved.');
    }
    const payload = await response.json();
    return payload.package;
  };

    const handleGenerate = async () => {
      if (!allReady) {
        console.warn('Attempted to generate before all data finished loading.');
        return;
      }
      const latest = await fetchLatestScheduleData();
      const generationData = latest.data;
      const generationCreditors = latest.creditors;
      const ABC = await generateScheduleABC({
        caseData,
        realProperties,
        vehicles,
        householdItems,
        financialAssets,
        businessAssets,
        farmAssets,
        otherProperties,
        exemptions,
        scope: exemptionScopeForCase(caseData),
        selectedSchedules,
        data: generationData,
      });

      if (ABC && selectedSchedules.includes('AB') || selectedSchedules.includes('C')){
      const link = document.createElement('a');
      link.href = URL.createObjectURL(ABC);
      link.download = 'ABC';
      link.click();
        }

              const amended = false;
      const [DEF, matrix] = await generateSchedulesPdfLocal(
        generationData,
        amended,
        selectedSchedules,
        generationCreditors,
      )
      if (DEF && (selectedSchedules.includes('D') || selectedSchedules.includes('EF') || selectedSchedules.includes('G') || selectedSchedules.includes('H'))){
      const DEFlink = document.createElement('a');
      DEFlink.href = URL.createObjectURL(DEF);
      DEFlink.download = 'DEF';
      DEFlink.click();
}
    if (matrix && selectedSchedules.includes('Matrix')){
      const matrixLink = document.createElement('a');
      matrixLink.href = URL.createObjectURL(matrix);
      matrixLink.download = 'Matrix';
      matrixLink.click();
      }

      const IJ = await generateScheduleIJ(
        caseData,
        expenses,
        expenseSheet,
        dependents,
        installments,
        selectedSchedules,
        generationData,
        meansTestIncomes,
        maritalAdjustments,
        longFormData
      )

      if (IJ && selectedSchedules.includes('I') || selectedSchedules.includes('J')) {
      const IJLink = document.createElement('a');
      IJLink.href = URL.createObjectURL(IJ);
      IJLink.download = 'IJ';
      IJLink.click();
      }
      const SUM = await generateSummary(
        caseData,
        generationData,
        expenses,
        installments,
        meansTestIncomes,
        realProperties,
        vehicles,
        householdItems,
        financialAssets,
        businessAssets,
        farmAssets,
        otherProperties,
        generationCreditors,
      )
            const DEC = await generateDecPage(
        caseData
      )
      const VOLP = await fillFormBrowser(petitionData)
      const SOFA = await generateSofa(caseData, generatedSofaData, generationData)

      if (SOFA && selectedSchedules.includes('Sofa')) {
        const sofaLink = document.createElement('a');
        link.href = URL.createObjectURL(SOFA);
        link.download = ('SOFA.pdf');
        link.click();
      }

        if (selectedSchedules.includes('all')) {
        const form2010Blob = await fetch('/forms/2010.pdf')
            .then(res => res.blob())
            .catch(() => null); // fallback if not found
        const blobsToMerge = [VOLP,SOFA, SUM, ABC, DEF, IJ, DEC,form2010Blob, matrix];

        const mergedPdf = await PDFDocument.create();

        for (const blob of blobsToMerge) {
            if (!blob) continue;
            const bytes = await blob.arrayBuffer();
            const pdf = await PDFDocument.load(bytes);
            const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            pages.forEach(page => mergedPdf.addPage(page));
        }

        const mergedBytes = await mergedPdf.save();
        const mergedBlob = new Blob([mergedBytes], { type: 'application/pdf' });

        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(mergedBlob);
        downloadLink.download = 'Full_Petition_Package.pdf';
        downloadLink.click();
        }



        ////this section below is where we build the Debtor.txt file

        ///starting with the stat line
        let feeStatus = 'i'
        if (caseData.filing_fee_method === 'installment')
            feeStatus = 'i'
        else if (caseData.filing_fee_method === 'waiver')
            feeStatus = 'w'
        else feeStatus = 'p'
        let debtType = 'c'
        if (caseData.debt_type === 'consumer')
            debtType = 'c'
        else if (caseData.debt_type === 'business')
            debtType = 'b'
        else debtType = 'o'
        const statLineSix = debtType === 'b' ? 'o' : ''
        let assetNotice = 'y'
        if (caseData.chapter === '7') assetNotice = 'n'

        let numCreditors = 'A'
        if (petitionData.creditor_count <50){
            numCreditors = 'A'
        } else if (petitionData.creditor_count <100) {
            numCreditors = 'B'
        } else if (petitionData.creditor_count <200) {
            numCreditors = 'C'
        } else if (petitionData.creditor_count <1000) {
            numCreditors = 'D'
        } else if (petitionData.creditor_count <5001) {
            numCreditors = 'E'
        } else if (petitionData.creditor_count <10001) {
            numCreditors = 'F'
        } else if (petitionData.creditor_count <25001) {
            numCreditors = 'G'
        } else if (petitionData.creditor_count <50001) {
            numCreditors = 'H'
        } else if (petitionData.creditor_count <100001) {
            numCreditors = 'I'
        } else {
            numCreditors = 'J'
        }

        let totalDebtStat = 'A'
        if (petitionData.total_debt_amount <50001){
            totalDebtStat = 'A'
        } else if (petitionData.total_debt_amount <100001) {
            totalDebtStat = 'B'
        } else if (petitionData.total_debt_amount <500001) {
            totalDebtStat = 'C'
        } else if (petitionData.total_debt_amount <1000001) {
            totalDebtStat = 'D'
        } else if (petitionData.total_debt_amount <10000001) {
            totalDebtStat = 'E'
        } else if (petitionData.total_debt_amount <50000001) {
            totalDebtStat = 'F'
        } else if (petitionData.total_debt_amount <100000001) {
            totalDebtStat = 'G'
        } else if (petitionData.total_debt_amount <500000001) {
            totalDebtStat = 'H'
        } else if (petitionData.total_debt_amount <1000000001) {
            totalDebtStat = 'I'
        } else if (petitionData.total_debt_amount <10000000001) {
            totalDebtStat = 'K'
        } else if (petitionData.total_debt_amount <50000000001) {
            totalDebtStat = 'L'
        } else {
            totalDebtStat = 'M'
        }
        const total_asset_amount = petitionData.real_property_total + petitionData.personal_property_total
        let assetAmountStat = 'A'
        if (total_asset_amount <50001){
            assetAmountStat = 'A'
        } else if (total_asset_amount <100001) {
            assetAmountStat = 'B'
        } else if (total_asset_amount <500001) {
            assetAmountStat = 'C'
        } else if (total_asset_amount <1000001) {
            assetAmountStat = 'D'
        } else if (total_asset_amount <10000001) {
            assetAmountStat = 'E'
        } else if (total_asset_amount <50000001) {
            assetAmountStat = 'F'
        } else if (total_asset_amount <100000001) {
            assetAmountStat = 'G'
        } else if (total_asset_amount <500000001) {
            assetAmountStat = 'H'
        } else if (total_asset_amount <1000000001) {
            assetAmountStat = 'I'
        } else if (total_asset_amount <10000000001) {
            assetAmountStat = 'K'
        } else if (total_asset_amount <50000000001) {
            assetAmountStat = 'L'
        } else {
            assetAmountStat = 'M'
        }

        let priorBKStat = 'n'
        petitionData.debtors.forEach((d, idx) => {
            if (d.prior_bankruptcies.length > 0) priorBKStat = 'y'
        })
        const securedDebts = data.debtsD.filter(d => d.debt_type === 'secured' && !d.additional_notified);
            const totalSecuredBalance = securedDebts
        .reduce((sum, c) => sum + parseFloat(c.balance || 0), 0);
        const priorityDebts = data.debtsE.filter(d => d.debt_type === 'priority' && !d.additional_notified);
            const totalPriorityBalance = priorityDebts
        .reduce((sum, c) => sum + parseFloat(c.balance || 0), 0);
            const unsecuredDebts = data.debtsF.filter(d => d.debt_type === 'unsecured' && !d.additional_notified);
            const totalUnsecuredBalance = unsecuredDebts
        .reduce((sum, c) => sum + parseFloat(c.balance || 0), 0);
        const totalIncomeStat = getTotalIncome(caseData)
          const j1ExpenseItems = expenses.filter(e => !e.j2);
        const j2ExpenseItems = expenses.filter(e => e.j2);
        const j1Installments = installments
            .filter(p => !p.j2)
            .map(p => ({ amount: Number(p.amount || 0), description: p.description }));
        const j2Installments = installments
            .filter(p => p.j2)
            .map(p => ({ amount: Number(p.amount || 0), description: p.description }));
        const j1Expenses = j1ExpenseItems.concat(j1Installments);
        const j2Expenses = j2ExpenseItems.concat(j2Installments);
            const j1Total = j1Expenses.reduce((sum, e) => sum + Number(e.amount || 0), 0);
        const j2Total = j2Expenses.reduce((sum, e) => sum + Number(e.amount || 0), 0);

        const totalExpense = j1Total + j2Total
        const totalMonthly = inc => (
            ['gross_wages','alimony','household_expenses','biz_net_monthly',
            'real_net_monthly','interest_dividends','unemployment','pension']
            .reduce((sum, k) => sum + (parseFloat(inc[k]) || 0), 0) +
            (inc.other_incomes?.reduce((s,o) => s + (parseFloat(o.amount)||0), 0) || 0)
        );
        const inc1 = meansTestIncomes.find(inc => inc.debtor.is_primary) || {};
        const inc2 = meansTestIncomes.find(inc => !inc.debtor.is_primary) || {};
        const m1 = totalMonthly(inc1);
        const m2 = totalMonthly(inc2);
        const combinedMonthly = m1 + m2;

        const un = data.debtsF.filter(d=>d.debt_type==='unsecured' && !d.additional_notified);
        const filterSum=(type)=>sumBy(un.filter(d=>{
        const at=(d.account_type||'').toLowerCase();
        if(type==='student_loan') return at.includes('student');
        if(type==='divorce') return at.includes('divorce');
        if(type==='pension') return at.includes('pension');
        if(type==='other') return !['student','divorce','pension'].some(k=>at.includes(k));
        return false;
      }),'balance');
        const sumBy = (arr, field)=>arr.reduce((s,c)=>s+(parseFloat(c[field])||0),0);
        const totalDSO = sumBy(priorityDebts.filter(d=>(d.priority_type||'').toLowerCase()==='dso'), 'priority_amount')
        const totalTax = sumBy(priorityDebts.filter(d=>(d.priority_type||'').toLowerCase()==='tax'), 'priority_amount')
        const totalIntox = sumBy(priorityDebts.filter(d=>(d.priority_type||'').toLowerCase()==='intox'), 'priority_amount')

        const totalSpecial = totalIntox + totalTax + totalDSO + filterSum('divorce') + filterSum('student_loan') + filterSum('pension')

        let primaryGrossWages = 0;
        let primaryPayrollDeductions = 0;
        let secondaryGrossWages = 0;
        let secondaryWageDeductions = 0;

        const primaryDebtorForCalc = caseData?.debtors?.find(d => d.is_primary) || null;
        const secondaryDebtorForCalc = caseData?.debtors?.find(d => !d.is_primary) || null;

        if (primaryDebtorForCalc?.employments?.length) {
          primaryDebtorForCalc.employments.forEach((emp) => {
            primaryGrossWages += calcGrossWages(emp);
            primaryPayrollDeductions += (emp.deductions || []).reduce((sum, d) => sum + Number(d.amount || 0), 0);
          });
        }

        if (secondaryDebtorForCalc?.employments?.length) {
          secondaryDebtorForCalc.employments.forEach((emp) => {
            secondaryGrossWages += calcGrossWages(emp);
            secondaryWageDeductions += (emp.deductions || []).reduce((sum, d) => sum + Number(d.amount || 0), 0);
          });
        }

        console.log(primaryGrossWages);
        console.log(primaryPayrollDeductions);
        console.log(secondaryGrossWages);
        console.log(secondaryWageDeductions);

        const filingDebtors = caseData.debtors.filter(d => d.is_filing);
        let maritalStatus = 'a'
        if (caseData.debtors.length === 2 && filingDebtors.length === 2) {
            maritalStatus = 'd'
        } else if (caseData.debtors.length === 2 && filingDebtors.length === 1) {
            maritalStatus = 'c'
        } else if (caseData.debtors.length === 1 && caseData.debtors[0]?.marital_status === 'separated') {
            maritalStatus = 'b'
        } else {
            maritalStatus = 'a'
        }
        const presumption = caseData.chapter === '7' && debtType === 'c' ? 'n' : ''
        const stateCode = primaryDebtorForCalc?.state || '';
        const householdSize = (caseData.debtors?.length || 0) + dependents?.length;
        const medianIncome = parseFloat(
            medianData[ STATE_NAMES[stateCode] ]?.[`${householdSize}`] || 0
        );
        let debtorTXT = []
        const statLine = `stat||||i|${statLineSix}||${caseData.chapter}|${feeStatus}|${debtType}|v||${assetNotice}|${numCreditors}|${assetAmountStat}|${totalDebtStat}|n|||y|${presumption}|||${priorBKStat}|`
            + `${petitionData.real_property_total}|${petitionData.personal_property_total}|${totalSecuredBalance.toFixed(2)}|${totalPriorityBalance.toFixed(2)}|${totalUnsecuredBalance.toFixed(2)}|`
            + `${totalIncomeStat.toFixed(2)}|${totalExpense.toFixed(2)}|${combinedMonthly.toFixed(2)}|${totalSpecial.toFixed(2)}||`
            + `|${primaryGrossWages.toFixed(2)}|${secondaryGrossWages.toFixed(2)}|${primaryPayrollDeductions.toFixed(2)}|${secondaryWageDeductions.toFixed(2)}|`
            + `${(totalIncomeStat - totalExpense).toFixed(2)}|||${maritalStatus}|${m1.toFixed(2)}|${m2.toFixed(2)}|${medianIncome}|${householdSize}|||||||||||||||||||||||||||||||||`
        debtorTXT.push(statLine)
        const primaryDebtor = caseData.debtors.filter(d => (d.is_filing && d.is_primary))[0]
        const secondaryDebtor = caseData.debtors.filter(d => (d.is_filing && !d.is_primary))[0]
        if (primaryDebtor){
                        
            const res = await fetch(`${BACKEND_API_URL}/api/geocode-fips`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ street: primaryDebtor.street, city: primaryDebtor.city, state: primaryDebtor.state, zip: primaryDebtor.zip_code })
            });
            const geoData = await res.json();
            const stateFips = String(geoData.tracts.features[0].attributes.STATE).padStart(2, '0');
            const countyFips = String(geoData.tracts.features[0].attributes.COUNTY).padStart(2, '0');
            const debtorLine = `debt|db|${primaryDebtor.first_name}|${primaryDebtor.second_name || ''}|${primaryDebtor.last_name}|`
            +   `|${primaryDebtor.suffix|| ''}|${primaryDebtor.ssn}||2|${primaryDebtor.street}|${primaryDebtor.street2 || ''}||${primaryDebtor.city}|${primaryDebtor.state}|${primaryDebtor.zip_code}|${stateFips}${countyFips}|`
            +   `|||`
            debtorTXT.push(debtorLine)
            if (primaryDebtor.aliases.length > 0){
                primaryDebtor.aliases.forEach((alias,idx) => {
                    const aliasLine = `alas|db|${alias.alias_type}|${alias.first_name}|${alias.second_name || ''}|${alias.last_name}`
                    debtorTXT.push(aliasLine)
                })
            }
        }
        if (secondaryDebtor){
            const res = await fetch(`${BACKEND_API_URL}/api/geocode-fips`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ street: secondaryDebtor.street, city: secondaryDebtor.city, state: secondaryDebtor.state, zip: secondaryDebtor.zip_code })
            });
            const geoData = await res.json();
            const stateFips = String(geoData.tracts.features[0].attributes.STATE).padStart(2, '0');
            const countyFips = String(geoData.tracts.features[0].attributes.COUNTY).padStart(2, '0');
            const debtorLine = `debt|jdb|${secondaryDebtor.first_name}|${secondaryDebtor.second_name || ''}|${secondaryDebtor.last_name}|`
            +   `|${secondaryDebtor.suffix || ''}|${secondaryDebtor.ssn}||2|${secondaryDebtor.street}|${secondaryDebtor.street2 || ''}||${secondaryDebtor.city}|${secondaryDebtor.state}|${secondaryDebtor.zip_code}|${stateFips}${countyFips}|`
            +   `|||`
            debtorTXT.push(debtorLine)
            if (secondaryDebtor.aliases.length > 0){
                secondaryDebtor.aliases.forEach((alias,idx) => {
                    const aliasLine = `alas|jdb|${alias.alias_type}|${alias.first_name}|${alias.second_name || ''}|${alias.last_name}`
                    debtorTXT.push(aliasLine)
                })
            }
        }
        const debtorTextContent = debtorTXT.join('\n');

        // Create a Blob from the text
        const textBlob = new Blob([debtorTextContent], { type: 'text/plain' });

        // Create a link and trigger download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(textBlob);
        link.download = 'Debtor.txt';
        link.click();
        
        


        };
        
    useEffect(() => { (async () => {
        // Fetch expense-related data
        const [expRes, payRes, depRes, sheetRes, incomesRes, adjRes, meansTestRes, sofaJson] = await Promise.all([
        fetch(`${API_URL}/cases/${caseId}/expenses/`, { headers: { Authorization: `Bearer ${TOKEN}` } }),
        fetch(`${API_URL}/cases/${caseId}/installment-payments/`, { headers: { Authorization: `Bearer ${TOKEN}` } }),
        fetch(`${API_URL}/cases/${caseId}/dependents/`, { headers: { Authorization: `Bearer ${TOKEN}` } }),
        fetch(`${API_URL}/cases/${caseId}/expense-sheet/`, { headers: { Authorization: `Bearer ${TOKEN}` } }),
        fetch(`${API_URL}/case/${caseId}/means-test/incomes/`,{ headers: { Authorization: `Bearer ${TOKEN}` } }),
        fetch(`${API_URL}/case/${caseId}/means-test/marital-adjustments/`, { headers: { Authorization: `Bearer ${TOKEN}` } }),
        fetch(`${API_URL}/case/${caseId}/means-test/`, { headers: { Authorization: `Bearer ${TOKEN}` } }),
        fetch(`${API_URL}/cases/${caseId}/sofa-generate/`, { headers: { Authorization: `Bearer ${TOKEN}` } }),
        ]);
        if (expRes.ok) setExpenses(await expRes.json());
        if (payRes.ok) setInstallments(await payRes.json());
        if (depRes.ok) setDependents(await depRes.json());
        if (sheetRes.ok) setExpenseSheet(await sheetRes.json());
        if (incomesRes.ok) setMeansTestIncomes(await incomesRes.json());
        if (adjRes.ok) setMaritalAdjustments(await adjRes.json());
        if (meansTestRes.ok) {
          const meansTestJson = await meansTestRes.json();
          setLongFormData(meansTestJson.long_form_data || {});
        }
        if (sofaJson.ok) setGeneratedSofaData(await sofaJson.json())
        // Fetch income items after fetching expense sheet
        const incomeRes = await fetch(`${API_URL}/cases/${caseId}/income-items/`, {
        headers: { Authorization: `Bearer ${TOKEN}` }
        });
        if (incomeRes.ok) {
        const incomeJson = await incomeRes.json();
        setIncomeItems(incomeJson);
        } else {
        setIncomeItems([]); // fallback to empty array if fetch fails
        }
        // Mark this batch of requirements as done (even if some requests failed, we don't want to freeze the UI)
        markFlagsDone(['expenses','installments','dependents','expenseSheet','means','maritalAdj','sofa','incomeItems']);
    })();
    }, [caseId, API_URL, TOKEN]);
 
  useEffect(() => {
      async function fetchData() {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${API_URL}/case/${caseId}/volp`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        if (!response.ok) {
          console.error('Failed to fetch petition data');
          return;
        }
        const caseData = await response.json();
        const filingDebtors = getFilingDebtors(caseData.debtors);
        setPetitionData({
          debtors: filingDebtors,
          chapter: caseData.chapter,
          first_name: filingDebtors[0]?.first_name || '',
          second_name: filingDebtors[0]?.second_name || '',
          last_name: filingDebtors[0]?.last_name || '',
          aliases: filingDebtors[0]?.aliases || [],
          ssn: filingDebtors[0]?.ssn || '',
          street: filingDebtors[0]?.street || '',
          street2: filingDebtors[0]?.street2 || '',
          city: filingDebtors[0]?.city || '',
          state: filingDebtors[0]?.state || '',
          zip_code: filingDebtors[0]?.zip_code || '',
          county: filingDebtors[0]?.county || '',
          mailing_street: filingDebtors[0]?.mailing_street || '',
          mailing_street2: filingDebtors[0]?.mailing_street2 || '',
          mailing_city: filingDebtors[0]?.mailing_city || '',
          mailing_state: filingDebtors[0]?.mailing_state || '',
          mailing_zip_code: filingDebtors[0]?.mailing_zip_code || '',
          prior_bankruptcies: filingDebtors[0]?.prior_bankruptcies || [],
          hazerdous_properties: caseData.hazerdous_properties || [],
          pending_bankruptcies: caseData.pending_bankruptcies || [],
          prior_bankruptcies: filingDebtors[0]?.prior_bankruptcies || [],
          intake_data: caseData.intake_data,
          filing_fee_method: caseData.filing_fee_method,
          filing_fee_amount: caseData.filing_fee_amount,
          debt_type: caseData.debt_type,
          execution_date: caseData.execution_date || new Date().toISOString().split('T')[0],
          alternative_venue_reason: caseData.alternative_venue_reason ?? '',
          creditor_count: caseData.creditor_count,
          case_number: caseData.case_number,
          total_debt_amount: caseData.total_debt_amount,
          real_property_total: caseData.real_property_total,
          personal_property_total: caseData.personal_property_total,
          being_evicted: caseData.being_evicted ?? false,
          liquidated_assets_in_7: caseData.liquidated_assets_in_7 ?? false,
          pays_rent: caseData.pays_rent ?? false,
          amended: false,
          amendedReason: '',
          amendedCreditors: [],
          fees_paid_prior: caseData.fees_paid_prior,
          share_fees: caseData.share_fees,
          fees_source:caseData.fees_source,
          fees_source_description:caseData.fees_source_description,
          fees_to_be_paid_source:caseData.fees_to_be_paid_source,
          fees_to_be_paid_description:caseData.fees_to_be_paid_description,
          total_attorney_fees:caseData.total_attorney_fees,
        });
        setCreditors(caseData.creditor_addresses || []);
        markFlagsDone(['petition']);
      }
      fetchData();
    }, [caseId]);
  useEffect(() => {
    async function fetchData() {
      try {
        const token = localStorage.getItem("accessToken");
        // Fetch case details and creditors in parallel
        const [caseRes, credRes] = await Promise.all([
          fetch(`${API_URL}/case/${caseId}/creditors/case-details/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(`${API_URL}/case/${caseId}/creditors/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        if (!caseRes.ok || !credRes.ok) {
          console.error("Failed to fetch case or creditors");
          return;
        }
        const caseJson = await caseRes.json();
        const credJson = await credRes.json();
        // Populate data object
        setData({
          caseInfo: caseJson,
          debtsD: credJson.filter(d => d.debt_type === "secured"),
          debtsE: credJson.filter(d => d.debt_type === "priority"),
          debtsF: credJson.filter(d => d.debt_type === "unsecured"),
          debtsG: credJson.filter(d => d.debt_type === "executory"),
          notifyEF: credJson.filter(d => d.additional_notified),
          allDebts : credJson,
        });
        // Build a simple address list for UI display
        const creditorAddresses = credJson.map(c => ({
          name: c.account_name || c.name,
          street1: c.street1 || '',
          street2: c.street2 || '',
          city: c.city || '',
          state: c.state || '',
          zip_code: c.zip_code || '',
          codebtor: c.codebtor || '',
          codebtor_street1:c.codebtor_street1 || '',
          codebtor_street2:c.codebtor_street2 || '',
          codebtor_state:c.codebtor_state || '',
          codebtor_zip_code:c.codebtor_zip_code|| '',
          codebtor_city:c.codebtor_city||'',
        }));
        setCreditors(creditorAddresses);
        markFlagsDone(['caseCreditors']);
      } catch (err) {
        console.error("Error fetching schedule data:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [caseId, API_URL]);
  useEffect(() => {
    async function fetchRealProperties() {
      try {
        const response = await fetch(
          `${API_URL}/case/${caseId}/list-real-properties/`,
          {
            headers: {
              'Authorization': `Bearer ${TOKEN}`,
            },
          }
        );
        if (!response.ok) throw new Error('Network response was not ok');
        const json = await response.json();
        setRealProperties(json);
      } catch (e) {
        console.error('Failed to fetch real properties', e);
        setError(e);
      } finally {
        setLoading(false);
        markFlagsDone(['realProps']);
      }
    }
    fetchRealProperties();
  }, [caseId]);

  // Fetch vehicle data
  useEffect(() => {
    async function fetchVehicles() {
      try {
        const res = await fetch(
          `${API_URL}/case/${caseId}/list-vehicles/`,
          { headers: { 'Authorization': `Bearer ${TOKEN}` } }
        );
        if (!res.ok) throw new Error('Network response was not ok');
        setVehicles(await res.json());
      } catch (e) {
        console.error('Failed to fetch vehicles', e);
        setVehicleError(e);
      } finally {
        setVehicleLoading(false);
        markFlagsDone(['vehicles']);
      }
    }
    fetchVehicles();
  }, [caseId]);

  useEffect(() => {
    async function fetchHouseholdItems() {
      try {
        const res = await fetch(
          `${API_URL}/case/${caseId}/list-household-items/`,
          { headers: { 'Authorization': `Bearer ${TOKEN}` } }
        );
        if (!res.ok) throw new Error('Network response was not ok');
        setHouseholdItems(await res.json());
      } catch (e) {
        console.error('Failed to fetch household goods', e);
        setHouseholdError(e);
      } finally {
        setHouseholdLoading(false);
        markFlagsDone(['household']);
      }
    }
    fetchHouseholdItems();
  }, [caseId]);

  useEffect(() => {
    async function fetchCase() {
      try {
        const res = await fetch(`${API_URL}/case/${caseId}/overview/`, {
          headers: { 'Authorization': `Bearer ${TOKEN}` },
        });
        if (!res.ok) throw new Error('Failed to load case');
        setCaseData(await res.json());
        markFlagsDone(['caseOverview']);
      } catch (e) {
        console.error(e);
      } finally {
        markFlagsDone(['caseOverview']);
      }
    }
    fetchCase();
  }, [caseId]);

  useEffect(() => {
    if (!caseData) return;
    setScope(exemptionScopeForCase(caseData));
  }, [caseData]);

  useEffect(() => {
    if (!scope) return;
    async function fetchExemptions() {
      try {
        const res = await fetch(
          `${API_URL}/exemptions/?state=${scope}`,
          { headers: { 'Authorization': `Bearer ${TOKEN}` } }
        );
        if (!res.ok) throw new Error('Failed to load exemptions');
        setExemptions(await res.json());
        markFlagsDone(['exemptions']);
      } catch (e) {
        console.error('Failed to fetch exemptions', e);
      } finally {
        markFlagsDone(['exemptions']);
      }
    }
    fetchExemptions();
  }, [scope]);

  // Fetch combined financial assets
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/assets/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      const json = await res.json();
      setFinancialAssets(json.financial || {});
      markFlagsDone(['finAssets']);
    })();
  }, [caseId]);

  // Fetch combined business assets
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/business-assets/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      const json = await res.json();
      setBusinessAssets(json.business || {});
      markFlagsDone(['bizAssets']);
    })();
  }, [caseId]);

  // Fetch combined farm assets
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/farm-assets/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      const json = await res.json();
      setFarmAssets(json.farm || {});
      markFlagsDone(['farmAssets']);
    })();
  }, [caseId]);

  // Fetch Other Properties
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/other-properties/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      setOtherProperties(await res.json());
      markFlagsDone(['otherProps']);
    })();
  }, [caseId]);

  // Recompute exemption summary whenever any asset or exemptions change
  
  // Block UI & clicks until everything is ready
  const LoadingOverlay = !allReady ? (
    <div className="fixed inset-0 z-50 bg-white/80 backdrop-blur-sm flex items-center justify-center">
      <div className="w-full max-w-xl mx-auto bg-white shadow-2xl rounded-xl p-6 border border-gray-200">
        <div className="flex items-center gap-3 mb-4">
          <svg className="animate-spin h-6 w-6" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <h3 className="text-lg font-semibold">Loading required data…</h3>
        </div>
        <p className="text-sm text-gray-600 mb-3">We’re fetching everything needed to generate the forms:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-60 overflow-auto">
          {Object.entries(loadFlags).map(([key, done]) => (
            <li key={key} className="flex items-center gap-2 text-sm">
              <span className={`inline-flex h-2.5 w-2.5 rounded-full ${done ? 'bg-green-500' : 'bg-amber-400 animate-pulse'}`} />
              <span>{loadingLabels[key] || key}</span>
            </li>
          ))}
        </ul>
        <div className="mt-4 text-xs text-gray-500">
          This overlay disappears automatically when everything’s ready.
        </div>
      </div>
    </div>
  ) : null;

    return (
      <>
      {LoadingOverlay}
      <section className="max-w-3xl mx-auto p-4 my-6">
        <FilingPackagePanel
          caseId={caseId}
          ready={allReady}
          onBuild={handleBuildFilingPackage}
        />
        <h1 className="text-3xl sm:text-4xl font-extrabold text-center text-gray-800 mb-8 tracking-tight">
          Bankruptcy Form Generator
        </h1>
        <h2 className="text-2xl font-bold text-center mb-6">1. Petition and Admin Forms</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <button
            type="button"
            onClick={() => handleVOLPGenerate(petitionData)}
            className="h-32 px-4 py-4 bg-white text-gray-900 rounded-lg shadow-2xl hover:shadow-3xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200 ease-in-out font-semibold flex items-center justify-center text-center transform hover:scale-105 hover:bg-gray-100 transition-transform duration-200 ease-in-out"
          >
            Generate Voluntary Petition
          </button>
          {petitionData.filing_fee_method === "installment" && (
            <button
              type="button"
              onClick={() => generateInstallmentAppPdf(petitionData)}
              className="h-32 px-4 py-4 bg-white text-gray-900 rounded-lg shadow-2xl hover:shadow-3xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200 ease-in-out font-semibold flex items-center justify-center text-center transform hover:scale-105 hover:bg-gray-100 transition-transform duration-200 ease-in-out"
            >
              Installment Application
            </button>
          )}
          <button
            type="button"
            onClick={() => generateSSNVerificationPdf(petitionData)}
            className="h-32 px-4 py-4 bg-white text-gray-900 rounded-lg shadow-2xl hover:shadow-3xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200 ease-in-out font-semibold flex items-center justify-center text-center transform hover:scale-105 hover:bg-gray-100 transition-transform duration-200 ease-in-out"
          >
            SSN Verification
          </button>
          <button
            type="button"
            onClick={() => generatePaymentAdvicesPdf(petitionData)}
            className="h-32 px-4 py-4 bg-white text-gray-900 rounded-lg shadow-2xl hover:shadow-3xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200 ease-in-out font-semibold flex items-center justify-center text-center transform hover:scale-105 hover:bg-gray-100 transition-transform duration-200 ease-in-out"
          >
            Payment Advices
          </button>
          <button
            type="button"
            onClick={() => generateAttorneyCompensationPdf(petitionData)}
            className="h-32 px-4 py-4 bg-white text-gray-900 rounded-lg shadow-2xl hover:shadow-3xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200 ease-in-out font-semibold flex items-center justify-center text-center transform hover:scale-105 hover:bg-gray-100 transition-transform duration-200 ease-in-out"
          >
            Attorney Disclosure
          </button>
          {/* DEBN forms for each debtor */}
          {petitionData.debtors.map((debtor, idx) => (
            <button
              key={debtor.id}
              type="button"
              onClick={() => generateDEBNFormsPdf(petitionData, debtor.is_primary)}
              className="h-32 px-4 py-4 bg-white text-gray-900 rounded-lg shadow-2xl hover:shadow-3xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200 ease-in-out font-semibold flex items-center justify-center text-center transform hover:scale-105 hover:bg-gray-100 transition-transform duration-200 ease-in-out"
            >
              DEBN for Debtor {idx + 1}
            </button>
          ))}
        </div>
        <h2 className="text-2xl font-bold text-center mb-6">
          2. Schedules
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
          {['AB','C','D','EF','G','H','I','J', 'SOI', 'Matrix', '122','SOFA','all'].map(type => {
            const isAll = type === 'all';
            const isSel = selectedSchedules.includes(type);
            return (
              <button
                key={type}
                type="button"
                onClick={() => {
                  setSelectedSchedules(prev => {
                    if (isAll) return ['all'];
                    const withoutAll = prev.filter(s => s !== 'all');
                    return withoutAll.includes(type)
                      ? withoutAll.filter(s => s !== type)
                      : [...withoutAll, type];
                  });
                }}
                className={`h-32 w-full px-4 py-4 rounded-lg shadow-2xl hover:shadow-3xl
                  font-semibold flex items-center justify-center text-center transform hover:scale-105 transition-transform duration-200 ease-in-out
                  ${isSel
                    ? 'bg-indigo-600 text-white hover:bg-indigo-700'
                    : 'bg-white text-gray-900 hover:bg-gray-100'
                  }`}
              >
                {isAll ? 'All' : `Schedule ${type}`}
              </button>
            );
          })}
        </div>
        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleGenerate}
            className={`mt-4 h-14 px-6 rounded-lg shadow-xl transform transition duration-200 font-semibold
              ${allReady ? 'bg-green-600 text-white hover:shadow-2xl hover:scale-105' : 'bg-gray-300 text-gray-600 cursor-not-allowed opacity-70'}
            `}
            disabled={!allReady}
          >
            Generate Selected Schedules
          </button>
        </div>
      </section>
    </>
    )
}
